module.exports = __webpack_public_path__ + "static/yt_thumb-a7e5641fc22b925327a9fe5d8356298f.png";